import React, { useState } from "react";
import axios from "axios";
import { api } from "../utils/Api";
import { Button, Form, notification, Select, Row, Col, Input } from "antd";

const SendStatements = ({ customerId, pcb, isEmail, startDate, endDate }) => {
	const [form] = Form.useForm();
	const [apiNotification, contextHolder] = notification.useNotification();
	const [loading, setLoading] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const onFinish = async (values) => {
		try {
			setLoading(true);
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const start = `${startDate.year()}-${
				startDate.month() + 1
			}-${startDate.date()}`;
			const end = `${endDate.year()}-${endDate.month() + 1}-${endDate.date()}`;

			const url =
				api +
				`/invoice/payment/customer/smsemail/${customerId}?startDate=${start}&endDate=${end}&type=${
					isEmail ? "email" : "sms"
				}`;
			const payload = {
				destination: isEmail ? values.email : `+1${values.phone}`,
			};
			const { data } = await axios.post(url, payload);
			if (data.success) {
				openNotification("success", "Success", data.message);
				setTimeout(() => {
					pcb();
				}, 1000);
			} else {
				openNotification("error", "Error", data.message);
				setLoading(false);
			}
		} catch (err) {
			openNotification("error", "Error", "Cannot send statements");
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	return (
		<Form
			form={form}
			layout="vertical"
			onFinish={onFinish}
			initialValues={{ prefix: "+1" }}
		>
			<Row gutter={16}>
				{isEmail ? (
					<Col span={24}>
						<Form.Item
							label="Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				) : (
					<Col span={24}>
						<Form.Item
							label="Phone"
							name="phone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
				)}
			</Row>
			<Button
				type="primary"
				htmlType="submit"
				size="large"
				loading={loading}
				disabled={loading}
			>
				Send
			</Button>
			{contextHolder}
		</Form>
	);
};

export default SendStatements;
